import axios from "axios";

export const API_ORIGIN = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  timeout: 90000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const extractToken = (data) =>
  data?.session_token || data?.access_token || data?.token || null;

export const extractUser = (data) => data?.user || data?.user_data || null;

export default api;
